import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import {
  context_styles
} from "../context_builder_dark_styles";
import "../context_dark.css";
import { LinearProgressDark } from "../context_components/styled_linear_progress";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSpring, animated } from '@react-spring/web';
import { StyledAutocompleteDark } from "../context_components/styled_autocomplete";
import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { analysisActions, contextBuilderActions, themeActions } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import ColorPicker from "../context_components/color_picker";
import TextField from "@mui/material/TextField";
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Collapse } from "@mui/material";
import { store } from "../../store/store";
import LinearAnalysis from "./audit_analysis_tabs/linearAnalysis";
import DrilldownAnalysis from "./audit_analysis_tabs/drillDownAnalysis";
import { Projects } from "../context_components/projects";

const useAutoCompleteStyles = makeStyles({
  option: {
    fontSize: '0.875rem',
  },
});

const useChipStyles = makeStyles({
  customChip: {
    backgroundColor: 'rgba(0, 255, 255, 0.15)',
    color: "rgba(245, 245, 245, 0.75)"
  },
});

const DarkSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: "rgba(0, 255, 255, 0.65)",
    '&:hover': {
      backgroundColor: alpha("rgba(0, 255, 255, 0.65)", theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: "rgba(0, 255, 255, 0.65)",
  },
}));

export default function Preferences(props) {
  const autocomplete_classes = useAutoCompleteStyles();
  const classes = useChipStyles();
  const { projectInfo, dateTime} = useSelector(state => state.projectInfoStore);
  const {
    color
  } = useSelector(state => state.themeStore);
  const {
    page,
    prevPage
  } = useSelector(state => state.contextBuilderStore);
  const dispatch = useDispatch();

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0
    },
    config: {
      mass: 7
    }
  }))

  useEffect(() => {
    api.start({
      from: {
        y: -15 + "%"
      },
      to: {
        y: 0 + "%"
      }
    })
  }, [])

  const handlePageChange = () => {
    dispatch(contextBuilderActions.changePage(prevPage));
  }

  const changeColor = (e) => {
    dispatch(themeActions.changeAccentColor(e.color))
  }

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={5} sx={context_styles}>
        {props.load &&
          <LinearProgressDark className="context-loader-dark" />
        }
        <Stack 
          spacing={1.5} 
          className="container"
        >
          <Stack direction="row" className="page-header-dark">
            <ChevronLeftIcon className="left-dark" onClick={handlePageChange} />
            <span>Preferences</span>
            <span className="right-dark"></span>
          </Stack>

          <Stack
            className="preferences-content"
            spacing={2}
          >
            <Stack
              direction="row"
              spacing={2}
              className="accent-switcher"
            >
              <span>Accent Color</span>
              <ColorPicker 
                type="accent-color"
                color={color}
                changeColor={changeColor}
              />
            </Stack>
          </Stack>
        </Stack>

        {/* project info/switcher */}
        <Projects />
      </Paper>
    </animated.div>
  )
}